export type MerchantRbacRoleState = {
  rbacScope?: boolean;
  status?: string;
  roleIds?: string[];
  permissions?: string[];
  merchantAdmin?: boolean;
};

/** A permission is effective only for ACTIVE members in the merchant RBAC scope. */
export const hasActiveMerchantPermission = (
  state: MerchantRbacRoleState | undefined,
  permission: string,
): boolean =>
  state?.rbacScope === true &&
  state.status === 'ACTIVE' &&
  Array.isArray(state.permissions) &&
  state.permissions.includes(permission);

/** Only the explicit ACTIVE + in-scope + empty-role state gets the guidance page. */
export const isActiveMerchantMemberWithoutRole = (state?: MerchantRbacRoleState): boolean =>
  state?.rbacScope === true &&
  state.status === 'ACTIVE' &&
  state.merchantAdmin !== true &&
  Array.isArray(state.roleIds) &&
  state.roleIds.length === 0;
